/** Capitalizes the first character of a string */
// TODO: Properly handle multi-byte unicode symbols
export const upperFirst = (s: string): string =>
  s === '' ? '' : s[0].toUpperCase() + s.slice(1);
